import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createCodingAgentButtonLabel: {
		id: 'autodev.agent-picker.create-coding-agent-button-label',
		defaultMessage: 'Create a developer Agent',
		description:
			'The label of the button that opens the dialog to create a new coding Rovo Agent from a template.',
	},
	createCodingAgentButtonSubLabel: {
		id: 'autodev.agent-picker.create-coding-agent-button-sub-label',
		defaultMessage: 'Use a template to customize a new Agent',
		description:
			'The sub-label of the button that opens the dialog to create a new coding Rovo Agent from a template.',
	},
});
